import { useTokenRefresh } from 'app/shared/hooks/use-token-refresh';

// Headless — runs the token-refresh hook inside the SDK/API/Router providers.
export const TokenRefreshManager = (): null => {
  useTokenRefresh();

  return null;
};
